export interface labelData {
  label: string;
  unit: string;
  // labelDataにキーを追加する場合は、isLabelDataにも判定を追加すること
}

/**
 * labelData型かどうかを返す
 * @param item 判定対象の値
 * @returns labelDataの型判定結果
 * 返却の型を`item is labelData`とすることで、labelData型であるかどうかを返却することができる。
 * 参考：https://typescript-jp.gitbook.io/deep-dive/type-system/typeguard#yznotype-guard
 */
export function isLabelData(item: any): item is labelData {
  return (
    typeof item == 'object' &&
    typeof item.label == 'string' &&
    typeof item.unit == 'string'
  );
}
